(() => {
  'use strict';
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  let paused=reduced.matches||document.body.dataset.hippoMotionEnabled==='false';
  try {if(localStorage.getItem('hippo-motion-paused')==='true')paused=true;} catch {}
  function updateMotion(){
    document.documentElement.classList.toggle('hippo-motion-paused',paused);
    document.querySelectorAll('[data-hippo-motion]').forEach(button=>{
      button.setAttribute('aria-pressed',String(paused));
      button.setAttribute('aria-label',paused?'Resume animations':'Pause animations');
      const icon=button.querySelector('span');if(icon)icon.textContent=paused?'▷':'Ⅱ';
      button.hidden=document.body.dataset.hippoMotionEnabled==='false';
    });
  }
  function initialise(scope=document){
    scope.querySelectorAll('[data-hippo-motion]').forEach(button=>{
      if(button.dataset.hippoReady)return;button.dataset.hippoReady='true';
      button.addEventListener('click',()=>{paused=!paused;try{localStorage.setItem('hippo-motion-paused',String(paused));}catch{}updateMotion();});
    });
    scope.querySelectorAll('[data-hippo-tabs]').forEach(section=>{
      if(section.dataset.hippoReady)return;section.dataset.hippoReady='true';
      const tabs=[...section.querySelectorAll('[role="tab"]')];
      const panels=[...section.querySelectorAll('[role="tabpanel"]')];
      const previous=section.querySelector('[data-hippo-prev]');
      const next=section.querySelector('[data-hippo-next]');
      let current=0;
      function rail(){return panels[current]?.querySelector('[data-hippo-rail]');}
      function updateArrows(){const r=rail();if(!r)return;if(previous)previous.disabled=r.scrollLeft<2;if(next)next.disabled=r.scrollLeft>=r.scrollWidth-r.clientWidth-2;}
      function activate(index,focus=false){
        if(index<0||index>=tabs.length)return;current=index;
        tabs.forEach((tab,i)=>{tab.classList.toggle('is-active',i===index);tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;});
        panels.forEach((panel,i)=>{panel.hidden=i!==index;});
        if(focus)tabs[index].focus();updateArrows();
      }
      tabs.forEach((tab,i)=>{
        tab.addEventListener('click',event=>{event.preventDefault();activate(i);});
        tab.addEventListener('keydown',event=>{
          let index=i;
          if(event.key===' '){event.preventDefault();activate(i);return;}
          if(event.key==='ArrowRight')index=(i+1)%tabs.length;
          else if(event.key==='ArrowLeft')index=(i+tabs.length-1)%tabs.length;
          else if(event.key==='Home')index=0;
          else if(event.key==='End')index=tabs.length-1;
          else return;
          event.preventDefault();activate(index,true);
        });
      });
      section.querySelectorAll('[data-hippo-rail]').forEach(r=>r.addEventListener('scroll',updateArrows,{passive:true}));
      function scroll(direction){const r=rail();if(r)r.scrollBy({left:direction*r.clientWidth*.8,behavior:paused||reduced.matches?'instant':'smooth'});}
      previous?.addEventListener('click',()=>scroll(-1));next?.addEventListener('click',()=>scroll(1));
      section.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('[role="tabpanel"]');const index=panels.indexOf(panel);if(index>=0)activate(index);});
      if(typeof ResizeObserver!=='undefined'){const observer=new ResizeObserver(updateArrows);observer.observe(section);section._hippoResizeObserver=observer;}
      activate(0);
    });
    updateMotion();
  }
  initialise();
  document.addEventListener('shopify:section:load',event=>initialise(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-hippo-tabs]').forEach(section=>section._hippoResizeObserver?.disconnect()));
  reduced.addEventListener('change',event=>{if(event.matches){paused=true;updateMotion();}});
})();
